import React, { Component } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import AuthStore from '../../Auth/AuthStore';
import { Chart } from 'primereact/chart';
import './report.css';

export class EffectivityReport extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            data: {
                labels: [],
                datasets: [
                    {
                        label: 'Эффективность',
                        backgroundColor: '#66BB6A',
                        data: [],
                        yAxisID: 'y-axis-1',
                    },
                    {
                        label: 'Всего SP',
                        yAxisID: 'y-axis-2',
                        backgroundColor: '#FFCA28',
                        data: []
                    }
                ]
            }
        };

        this.loadReport = this.loadReport.bind(this);
    }

    componentDidMount() {
        this.loadReport();
    }

    loadReport() {
        var scope = this;
        scope.setState({ loading: true });

        var token = localStorage.getItem("token");

        fetch('api/Report/GetMonthEffectivity', {
            method: 'GET',
            body: null,
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                scope.setState({ loading: false });
                AuthStore.openLogin();
            }
            else {
                res.json().then((result) => {
                    console.log(result);
                    var data = {
                        labels: [],
                        datasets: [
                            {
                                label: 'Эффективность',
                                backgroundColor: '#66BB6A',
                                data: [],
                                yAxisID: 'y-axis-1',
                            },
                            {
                                label: 'Всего SP',
                                yAxisID: 'y-axis-2',
                                backgroundColor: '#FFCA28',
                                data: []
                            },
                            {
                                label: 'Всего Часов',
                                yAxisID: 'y-axis-3',
                                backgroundColor: '#36A2EB',
                                data: []
                            }
                        ]
                    };

                    data.labels = result.map(r => r.name);
                    data.datasets[0].data = result.map(r => r.effectivity.toFixed(2));
                    data.datasets[1].data = result.map(r => r.sp);
                    data.datasets[2].data = result.map(r => (r.minutes/60).toFixed(1));

                    scope.setState({ data: data, loading: false });
                }).catch((err) => console.log(err));
            }
        });
    }

    render() {
        const multiAxisOptions = {
            responsive: true,
            tooltips: {
                mode: 'index',
                intersect: true
            },
            scales: {
                yAxes: [{
                    type: 'linear',
                    display: true,
                    position: 'left',
                    id: 'y-axis-1',
                    ticks: {
                        min: 0,
                        max: 160
                    }
                },
                {
                    type: 'linear',
                    display: true,
                    position: 'right',
                    id: 'y-axis-2',
                    gridLines: {
                        drawOnChartArea: false
                    },
                    ticks: {
                        min: 0,
                        max: 160
                    }
                },
                {
                    type: 'linear',
                    display: true,
                    position: 'right',
                    id: 'y-axis-3',
                    gridLines: {
                        drawOnChartArea: false
                    },
                    display: false,
                    ticks: {
                        min: 0,
                        max: 160,
                        display: false
                    }
                }]
            }
        }

        return (
            <div>
                <h3>Эффективность, за 30 дней</h3>
                {this.state.loading && <div className="block-progress-mask"><CircularProgress color="inherit" /></div>}
                {!this.state.loading && <Chart type="bar" data={this.state.data} options={multiAxisOptions} />}
            </div>
        )
    }
}